import { useCallback, useRef } from 'react'

type ContentGroupRefs = Record<string, HTMLDivElement | null>

export const NAVIGABLE_OFFER_CONTENT_SCROLL_OFFSET = 71
export const BEDBANK_NAVIGABLE_OFFER_CONTENT_SCROLL_OFFSET = 74

function useNavigableOfferContentScroll(offset: number) {
  const contentGroupRefs = useRef<ContentGroupRefs>({})

  const scrollToContentGroup = useCallback((id: string) => {
    const targetGroup = contentGroupRefs.current[id]

    if (!targetGroup) return

    const targetY = window.pageYOffset + targetGroup.getBoundingClientRect().top - offset
    window.scrollTo(0, targetY)
  }, [offset])

  return {
    contentGroupRefs,
    scrollToContentGroup,
  }
}

export default useNavigableOfferContentScroll
